import type { QueryKeyData, QueryParams } from '@pba/react-query';
import { type SearchResultsData, createSearchResultsData } from 'models';
import { useQuery } from 'query';
import { getGlobalSearch } from '../services';
import { getGlobalSearchInputQueryKey } from './keys';

export type GetGlobalSearchInputParameters = QueryParams<GlobalSearchInputQueryData, GlobalSearchInputFilter>;

export type GlobalSearchInputFilter = {
  query?: string;
};

export type GlobalSearchInputQueryData = QueryKeyData<SearchResultsData, typeof getGlobalSearchInputQueryKey>;

export const useGlobalSearchInputQuery = ({ filter }: GetGlobalSearchInputParameters) =>
  useQuery<SearchResultsData>({
    enabled: Boolean(filter.query),
    async queryFn() {
      const result = await getGlobalSearch({ config: { params: { query: filter.query } } });
      return createSearchResultsData(result.data);
    },
    queryKey: getGlobalSearchInputQueryKey({ filter }),
  });
